export const HMapTabs = [
  {
    id: 0,
    code: 'active',
    title: 'Active'
  },
  {
    id: 1,
    code: 'user',
    title: 'My'
  },
  {
    id: 2,
    code: 'business',
    title: 'Business'
  },
  {
    id: 3,
    code: 'system',
    title: 'System'
  }
]